// Merged activity+issue feed, newest first — the same shape and sort rule
// the site dashboard and the owner dashboard both need, shared here so a
// future third consumer doesn't hand-roll a third copy.
import type { Activity, Issue } from '$lib/types';

export type TimelineEntry =
  | { kind: 'activity'; created_at: string; activity: Activity }
  | { kind: 'issue'; created_at: string; issue: Issue };

export function mergeTimeline(activities: Activity[], issues: Issue[]): TimelineEntry[] {
  const acts: TimelineEntry[] = activities.map((a) => ({ kind: 'activity', created_at: a.created_at, activity: a }));
  const iss: TimelineEntry[] = issues.map((i) => ({ kind: 'issue', created_at: i.created_at, issue: i }));
  return [...acts, ...iss].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
}
